module.exports = __webpack_public_path__ + "img/students-comment.261efe1a.png";